import { Component, OnInit, ViewChild, ElementRef, Input, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ProductService } from 'app/products/service/product.service';
import { HttpService } from 'app/shared/services/http.service';
import * as emiGlobals from 'app/globals';
import { InputType, InputTypeValidation,QuestionCategory } from 'app/globals';
import { DomSanitizer } from '@angular/platform-browser';
import { CalculatorService } from 'app/calculators/calculator.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import { ProductOffer } from "app/calculators/Product";



@Component({
  selector: 'app-sub-products-question',
  templateUrl: './sub-products-question.component.html',
  styleUrls: ['./sub-products-question.component.css']
})
export class SubProductsQuestionComponent implements OnInit {



  
  @ViewChild('videoPlayer') videoplayer: any;
  @ViewChild('companySelect') public companySelect: ElementRef;
  @ViewChild('slider') slider: any;
  @Input('configData') data;


  productOffer: ProductOffer = new ProductOffer();

  loanApplyForm: FormGroup;
  questionForm: FormGroup;
  form: FormGroup;


  showDropdown: boolean;
  showTextField: boolean;
  showRadioButton: boolean;
  showStarRating: boolean;
  showImage: boolean;
  showCheckbox: boolean;
  showVideo: boolean;
  showcompany: boolean;
  showDefaultOffer: boolean;
  showSubCheckbox: boolean;
  showButton: boolean;
  showSubField: boolean;
  showHeading: boolean;
  showCheckField: boolean;
  enableSubmit: boolean;
  showBankList: boolean;
  

  offer: any;
  roi: any;
  condition: any;
  bankName: any;
  radioButtonList: any;
  resultList: any;
  maxStarList: any[];
  noOfStars = 5;
  ratedCount: any;
  url = '';
  imageUrl: any;
  description: any;
  checkboxList: any;
  videoUrl: any;
  displayUrl: any;
  defaultOfferList: any;
  productId: any;
  objectProps: any;
  dataObject: any;
  comapny_selector;
  type: any;
  subdropDownList: any;
  dropdownName: any;
  showTextBox: any;
  showTab: any;
  pf: any;
  pc: any;
  questionId: any;
  i: any = 0;
  limit = 1;
  active_group_id = 0;
  total_question_set: any;
  question_answer: { [id: string]: any } = {};
  question_catgeory: { [id: string]: any } = {};
  activeButton: any;
  options_bank: any;


  companyId = [];
  newSubList = [];
  checkList = [];
  subQuestionList = [];
  subList = [];
  dataList = [];
  questionList = [];
  answerList = [];
  dropDownList = [];

  showForm: boolean;

  @ViewChild('search') public searchElementRef: ElementRef;
  constructor(public httpService: HttpService, private fb: FormBuilder,
    private ngZone: NgZone, private sanitizer: DomSanitizer, public calculatorService: CalculatorService,
    public router: Router, private loanOfferService: LoanOfferGenService, public route: ActivatedRoute) {
  }

  ngOnInit() {

    this.route.params.subscribe(routeParams => {
      this.productOffer.groupId = routeParams['id'];
      console.log('-----routeParams' , routeParams['id']);
     });

   
    console.log('----inside question component ------', this.data);
    this.productId = this.data.productId;
    this.questionList = this.data.configData;
    this.dataObject =  this.questionList;
   
    this.getFormData(); // to get dynamic form fields
    // this.httpService.getById(emiGlobals.DynamicFormUrl + '/' + this.productId).subscribe(result => {
    //   debugger
    //   this.dataObject = result;
    //   console.log('-----this.dataObjectthis.dataObject' , this.dataObject);
    //   this.showForm  = true;
    //      this.getFormData(); // to get dynamic form fields
    // });

    this.loanApplyForm = this.fb.group({
      'field': ['', Validators.compose([Validators.required])]
    })

    this.questionForm = this.fb.group({
      'text': ['', Validators.compose([Validators.required])],
      'employername': [null],
    });
    this.ratedCount = 0;
    this.dropDownList = [];
    this.type = 'text';
    this.showTextField = true;
    this.showStarRating = false;
    this.maxStarList = [];
    for (let star = 0; star < this.noOfStars; star++) {
      this.maxStarList.push(star + 1);
    }
    //   this.defaultOffer();

    
  }

  // To get company list 
  ngAfterViewInit() {
    const token = localStorage.getItem('id_token');
    this.productOffer.listType = this.data.listId;
    this.comapny_selector = (<any>$(this.companySelect.nativeElement)).tokenInput(emiGlobals.companyBankListUrl + '/' + this.data.listId + '?token=' + token, {
      theme: 'facebook',
      minChars: 3,
      preventDuplicates: true,
      hintText: 'Search your company name',
      crossDomain: false,
      onResult: function (company: any) {
        var PlCompanyListFiltered = [];
        if (this.PlCompanyListFiltered) {
          PlCompanyListFiltered.length = 0;
        }
        PlCompanyListFiltered = company;
        company = PlCompanyListFiltered;
        if ($.isEmptyObject(company)) {
          var text = $('tester').text();
          return [{ id: '0', name: text.replace('Company Name', '') }];
        } else {
          $('.gifImage').hide();
          return company;
        } 
      },

      get: function () {
        return this.data('tokenInputObject').getTokens();
      },
    });

var isFF = true;
var addRule = (function (style) {
  var sheet = document.head.appendChild(style).sheet;
  return function (selector, css) {
    
  };
})(document.createElement("style"));


// .chrome styling
$( '.chrome input' ).on( 'input', function( ) {
  $( this ).css( 'background', 'linear-gradient(to right, green 0%, green '+this.value +'%, #fff ' + this.value + '%, white 100%)' );
} );


  }

  //  dynamic form 
  getFormData() {
    if (this.dataObject !== null && this.dataObject !== undefined) {
      // remap the API to be suitable for iterating over it
      this.objectProps =
        Object.keys(this.dataObject)
          .map(prop => {
            return Object.assign({}, { key: prop }, this.dataObject[prop]);
          });
      // setup the form
      const formGroup = {};
      for (let prop of Object.keys(this.dataObject)) {
        formGroup[prop] = new FormControl(this.dataObject[prop].value || '', this.mapValidators(this.dataObject[prop].validation));
        console.log("formGroup", formGroup);
      }
      this.form = new FormGroup(formGroup);
    }
  }

  // on submit of dynamic form
  onSubmit(form) {
    console.log(form);
  }

  // dynamic form validation
  private mapValidators(validators) {
    const formValidators = [];
    if (validators) {
      for (const validation of Object.keys(validators)) {
        if (validation === 'required') {
          formValidators.push(Validators.required);
        } else if (validation === 'min') {
          //  formValidators.push(Validators.min(validators[validation]));
        }
      }
    }
    return formValidators;
  }
  onChangeOfOption(event) {

  }
  onCheckboxChange(row, event) {
    this.showHeading = true;
    if (event.target.checked === true) {
      // to display checked headings
      this.httpService.getById(emiGlobals.subQuestionDropdownUrl + '/' + row.id).subscribe(result => {
        this.newSubList.push({
          'dropdown': result[0].questions,
          'id': result[0].id,
          'option_id': result[0].option_id
        });
        if (this.newSubList.length > 1) {
          this.showHeading = true;
        }
      });
    }
    this.httpService.getById(emiGlobals.questionUrl + '/' + row.id).subscribe(result => {
      this.subList = result;
    });
  }

  // on click of radio button
  onItemChange(data) {
    debugger
   this.activeButton = data.id;
   this.next(this.active_group_id);

   if (data.category_id === QuestionCategory.city) {
     this.productOffer.locationId =  data.id;
   }
   if (data.category_id === QuestionCategory.gender) {
    this.productOffer.gender =  data.id;
   }
  }

  // on click of back button
  back(id) {
    this.type = '';
    if (id !== null) {
      this.active_group_id = id - 1;
    }
    this.next(id - 2);
  }


  getGroupId(i) {
    return Math.floor(i / this.limit);
  }

  // on change of input field 
  onchangeOfanswer(q, answer, qn) {
    let tokenInput = this.comapny_selector.tokenInput('get');
    this.question_answer[qn.id] = answer;
    this.question_catgeory[qn.id] = qn.category_id;
  }

  // on click of check offer button
  onClickOfCheckOffer() {
    this.showSubField = true;
    this.calculatorService.SearchCategory = '4';
    this.dataList.length = 0;
    this.showDefaultOffer = true;
    // tslint:disable-next-line:forin
    for (const key in this.question_answer) {
      this.dataList.push({
        'id': Number(key),
        'value': this.question_answer[key],
        'category_id': this.question_catgeory[key]
      });
    }
    // let tokenInput = this.comapny_selector.tokenInput('get');
    // tokenInput.forEach(input => {
    //   this.companyId.push(input.id);
    // });
    // this.dataList.push({
    //   'id': '',
    //   'value': this.companyId,
    //   'category_id': 10
    // });
    this.productOffer.product = this.data.productId;
    this.productOffer.questionAnswer = this.dataList;
    this.productOffer.bankId = this.data.bankId;
    this.productOffer.questionSetId = this.data.questionSetId;

   
      this.httpService.create(emiGlobals.companySpecificOfferUrl, this.productOffer).subscribe(result => {
        const value = JSON.parse(result._body);
        this.offer = value;
        this.calculatorService.getCurrentData(this.offer);
        this.calculatorService.getInputData(this.productOffer);
        this.router.navigate(['/group-details'], this.productOffer.groupId);
      });
    

    // if (tokenInput.length !== 0) {
    //   if (this.productOffer !== undefined) {
    //     this.httpService.create(emiGlobals.companySpecificOfferUrl, this.productOffer).subscribe(result => {
    //       const value = JSON.parse(result._body);
    //       this.offer = value;
    //       this.calculatorService.getCurrentData(this.offer);
    //       this.calculatorService.getInputData(this.productOffer);
    //       // this.router.navigateByUrl(this.url);
    //      // this.router.navigate(['savings']);
    //     });
    //   }
    // } else {
    //   if (this.productOffer !== undefined) {
    //     this.httpService.create(emiGlobals.productOfferUrl + '/' + this.productOffer.product, this.productOffer).subscribe(result => {
    //       const value = JSON.parse(result._body);
    //       this.offer = value;
    //       this.calculatorService.getCurrentData(this.offer);
    //       this.calculatorService.getInputData(this.productOffer);
    //      // this.router.navigate(['savings']);
    //     });
    //   }
    // }
    this.httpService.create(emiGlobals.loanEligibiltyUrl, this.productOffer).subscribe(
      result => {
        this.calculatorService.getLoanEligibilty(JSON.parse(result._body));
      }
    );
  }
  submitForm(value) {
    this.httpService.getAll(emiGlobals.productOfferUrl + '/' + this.data.productId + '/' + value.loanamt + '/' +
      value.salary + '/' + value.tenure).subscribe(result => {
        this.offer = result;
        if (result[0]) {
          this.roi = this.offer[0].ROI;
          this.condition = this.offer[0].Conditions;
          this.pf = this.offer[0].PF;
          this.pc = this.offer[0].PC;
        }
      });
  }

  // on click of next button  
  next(id) {
    debugger
    this.showHeading = false;
    this.showSubField = false;
    let tokenInput = this.comapny_selector.tokenInput('get');
    console.log('---inside next---', id);
    this.showDefaultOffer = true;
    this.questionList.forEach(element => {
      const index = this.questionList.indexOf(element);
      console.log('------------element----------------', element);
      if (index === id + 1) {
        if (element.option_id === InputType.button) {
          debugger
          console.log('------------11111111111111111111----------------', index);
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            if (result.length > 0) {
              this.dropDownList = result;
              this.dropDownList.forEach(option => {
                if (element.id === option.question_id) {
                  debugger
                  this.showcompany = false;
                  this.showTextField = false;
                  this.showRadioButton = false;
                  this.showStarRating = false;
                  this.showImage = false;
                  this.showCheckbox = false;
                  this.showVideo = false;
                  this.showDropdown = true;
                }
              });
            }
          });
        } else if (element.option_id === InputType.text) {
          console.log('------------2222222222222222222----------------', element);
          if (element.category_id === QuestionCategory.company) {
            console.log('-------10000000000000000000000000000---------------');
            this.showTextField = false;
            this.showcompany = true;
            jQuery('body').on('focus', '#token-input-employername', function (event) {
              console.log('-------jquery---------------', event);
            });
          } else if (element.category_id === QuestionCategory.salaryAccountBank) {
            this.showTextField = false;
            this.showcompany = false;
            this.showBankList = true;
            this.options_bank = this.loanOfferService.getBankList();
          } else {
            this.showcompany = false;
            this.showBankList = false;
          }
          this.showDropdown = false;
          this.showRadioButton = false;
          this.showStarRating = false;
          this.showImage = false;
          this.showVideo = false;
          this.showCheckbox = false;
          this.showTextField = true;
         } else if (element.option_id === InputType.radio) {
          this.showTextField = false;
          this.showDropdown = false;
          this.showImage = false;
          this.showStarRating = false;
          this.showCheckbox = false;
          this.showVideo = false;
          this.showRadioButton = true;
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            this.radioButtonList = result;
          });
        } else if (element.option_id === InputType.date) {
          console.log('------------444444444444444444----------------');
          this.showDropdown = false;
          this.showRadioButton = false;
          this.showImage = false;
          this.showStarRating = false;
          this.showVideo = false;
          this.showCheckbox = false;
          this.showTextField = true;
          this.type = 'date';
        } else if (element.option_id === InputType.image) {
          console.log('------------55555555555555555555-------------');
          this.showDropdown = false;
          this.showRadioButton = false;
          this.showImage = false;
          this.showStarRating = false;
          this.showCheckbox = false;
          this.showVideo = false;
          this.type = 'file';
          this.showTextField = true;
        } else if (element.option_id === InputType.ratings) {
          this.showDropdown = false;
          this.showRadioButton = false;
          this.showTextField = false;
          this.showImage = false;
          this.showVideo = false;
          this.showCheckbox = false;
          this.showStarRating = true;
        } else if (element.option_id === InputType.cards) {
          this.showDropdown = false;
          this.showRadioButton = false;
          this.showTextField = false;
          this.showStarRating = false;
          this.showCheckbox = false;
          this.showVideo = false;
          this.showImage = true;
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            this.resultList = result;
            this.resultList.forEach(data => {
              if (data.image_url) {
                this.imageUrl = data.image_url.split(',');
                this.description = data.description.split(',');
              }
            });
          });
        }  else if (element.option_id === InputType.checkbox) {
          debugger
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            this.checkboxList = result;
          });
          this.showDropdown = false;
          this.showImage = false;
          this.showRadioButton = false;
          this.showStarRating = false;
          this.showTextField = false;
          this.showVideo = false;
          this.showcompany = false;
          this.showCheckbox = true;
          this.showSubCheckbox = false;
        
        } else if (element.option_id === InputType.video) {
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            console.log('---result----', result);
            this.videoUrl = result[0].video_url;
            const videoId = this.videoUrl.split('?v=');
            const YouTubeVideoId = videoId[1];
            var quote_str = 'https://www.youtube.com/embed/' + YouTubeVideoId + "";
            console.log('---viideo url---', quote_str);
            const url = 'https://www.youtube.com/embed/tgbNymZ7vqY';
            this.displayUrl = this.sanitizer.bypassSecurityTrustResourceUrl(quote_str);
            console.log('---displayUrl url---', this.displayUrl);
          });
          this.showCheckbox = false;
          this.showDropdown = false;
          this.showImage = false;
          this.showRadioButton = false;
          this.showStarRating = false;
          this.showTextField = false;
          this.showVideo = true;
        }
      }
    }); // end of questionList
    if (id != null) {
      this.active_group_id = id + 1;
    }
    if (id === this.questionList.length - 2) {
      this.enableSubmit = true;
    }
  }   //  end of next 

  // on change of star rating

  toggleRating(s: number) {
    this.ratedCount = s;
  }


  defaultOffer() {
    this.httpService.getAll(emiGlobals.productOfferUrl + '/' + this.data.productId + '/' + 500000 + '/' +
      45000 + '/' + 12).subscribe(result => {
        this.defaultOfferList = result;
        if (result[0]) {
          console.log('-----offer default---', result[0]);
        }
      });
  }

  // on tab click
  onTabClick(value) {
    this.showTab = value.id;
    this.httpService.getById(emiGlobals.questionUrl + '/' + value.id).subscribe(result => {
      this.subQuestionList = result;
      this.subQuestionList.forEach(element => {
        if (element.option_id === InputType.checkbox) {
          this.httpService.getById(emiGlobals.optionUrl + '/' + element.id).subscribe(result => {
            this.checkList = result;
          });
        }
      });
    });
  }
 

  // on click of bank
  OnClickOfBank(bank) {
    this.productOffer.salaryAccountBank = bank.value;
    this.next(this.active_group_id);
  }

  // on change of sliders
  onChangeOfSlider(value) {
    console.log(value);
    this.productOffer.rangeSliderValue = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/company-details/sub-products-question/sub-products-question.component.ts